/**
 * @desc 通过spu编号获取sku编号列表
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<string>>;
export function request(spuNo: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/rpc/sku/getSkuNoListBySpuNo/${spuNo}`, {
      method: "GET",

      ...options,
    }),
  );
}
